import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TeamsTable from '../../Components/PostEx6/Teams/TeamsTable';
import AppointeesView from '../../Components/PostEx6/Appointees/AppointeesView';
import { qualYearSelect, apptTypesSelect } from '../../../../../Redux/Selectors/Contracts.Globals.Selectors';
import { CONTRACT_GLOBALS_ERROR } from '../../../../../Redux/Enums/Contracts.Globals.Enums';

import styles from './styles.module.css';

const PostEx6 = () => {
	const { isLoaded: qualYearLoaded, selected: qualYear } = useSelector(qualYearSelect);
	const { isLoaded: apptTypesLoaded, selected: apptTypes } = useSelector(apptTypesSelect);
	const dispatch = useDispatch();
	let qualYearAssigned = qualYear;

	const handleErrors = errors =>
		dispatch({
			type: CONTRACT_GLOBALS_ERROR,
			payload: { errors }
		});	

	const initialTeam = {
		apptType: '',
		teamTitle: '',
		teamCode: '',
		teamId: '',
		year: 0
	};
	const [team, setTeam] = useState(initialTeam);
	const { teamId } = team;

	if (!qualYearLoaded) {
		handleErrors(['Cannot show Post EX6 as no qualification year is loaded']);
		return null;
	}

	if (!apptTypesLoaded) {
		handleErrors(['Cannot show Post EX6 as no Appointment Types are loaded']);
		return null;
	}

	if (teamId === '') {
		return <TeamsTable setTeam={setTeam} qualYear={qualYearAssigned} apptTypes={apptTypes} handleErrors={handleErrors} className={styles.teams} />;
	}

	return <AppointeesView {...team} setTeam={setTeam} handleErrors={handleErrors} initialTeam={initialTeam} />;
};

export default PostEx6;
